import React from 'react';
import { Link } from 'react-router-dom';

interface SubmissionClosedStateProps {
  closeDate: Date;
}

const SubmissionClosedState: React.FC<SubmissionClosedStateProps> = ({
  closeDate,
}) => {
  const formattedDate = closeDate.toLocaleDateString('en-ID', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });

  const formattedTime = closeDate.toLocaleTimeString('en-ID', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

  return (
    <div className="max-w-xl mx-auto my-12 animate-slide-up">
      <div className="bg-white rounded-3xl shadow-smdd-card border border-gray-200 overflow-hidden relative">
        {/* Accent Top Bar */}
        <div className="h-2 bg-gradient-to-r from-smdd-red via-smdd-yellow to-smdd-blue" />

        <div className="p-8 md:p-12 text-center">
          {/* Animated Lock/Calendar Icon Container */}
          <div className="w-24 h-24 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-8 animate-float shadow-soft border border-red-100">
            <svg
              className="w-12 h-12 text-smdd-red"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="1.5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
              />
            </svg>
          </div>

          {/* Headline */}
          <h2 className="text-3xl font-baijamjuree-extrabold text-smdd-black mb-4 tracking-tight leading-tight">
            Submissions Closed
          </h2>

          {/* Description */}
          <p className="text-gray-600 font-bai text-lg mb-8 leading-relaxed">
            Thank you for your interest in the Sinar Mas Digital Awards. The
            submission period for the pre-selection stage is now officially
            closed.
          </p>

          {/* Date Badge */}
          <div className="inline-flex items-center space-x-3 bg-smdd-gray px-6 py-4 rounded-2xl border border-gray-300/80 mb-8 max-w-full text-left">
            <svg
              className="w-6 h-6 text-gray-500 flex-shrink-0"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
              />
            </svg>
            <div>
              <div className="text-xs text-gray-500 font-bai font-bold uppercase tracking-wider">
                Deadline
              </div>
              <div className="text-base font-bai font-semibold text-gray-800">
                {formattedDate} at {formattedTime} (GMT+7)
              </div>
            </div>
          </div>

          <div className="h-px bg-gray-200 w-full mb-8" />

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/"
              className="w-full sm:w-auto px-8 py-3 bg-smdd-black text-white hover:bg-zinc-800 rounded-xl font-bai font-semibold shadow-soft hover:shadow transition-all text-center"
            >
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubmissionClosedState;
